<template>
    <div class="not-found">
        404
    </div>
</template>
<script>
// 路由错误页面
export default {};
</script>
<style lang="scss" scoped>
.not-found {
    background: #fff;
    width: 100vw;
    height: 100vh;
    text-align: center;
    font-size: 36px;
    padding-top: 200px;
    color: rgb(170, 170, 170);
}
</style>
